const deviceType = {
    weatherSensors:'weatherSensors',
    thermoSmarts:'thermoSmarts',
    environSyncs:"environSyncs",
    energiSync:'energiSync',
    doorSensors:'doorSensors'
}

const typeOfConfigration ={
  systemValues:'systemValues',
  graph:"graph"
}
const pnbProperties = [
  "6993297f34800267d30e153a",
  "69932a4634800267d30f444a",
  "69932b5b34800267d310d40d",
  "69932bfe34800267d311d77c",
  "69932cb334800267d312ce08",
  "69932e1534800267d315357f"
]


// Clients whose properties get the Device Moved tool.
const deviceMoveClients = [
  "6a300375f18e7e790d1b97f3"
]

export const config ={
  deviceType,
  typeOfConfigration,
  pnbProperties,
  deviceMoveClients
}